import { modules, searchTerms } from "../../constants";
import { viewTypes } from "../../dashboard/constants";

export const dashboardView = ( initialView ) => ({
    ...initialView,
    id: modules.dashboard.dashboard,
    searchFilters: [
        searchTerms.mlsFilter,
    ],
    viewTypeId: viewTypes.byOffice.id,
    selectedOffice: {},
});
